import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import modal from 'decorators/Modal/Modal';
import { decorateWith, withName } from 'helpers/decorator';

export class ModalErrorUnwrapped extends PureComponent {
  componentDidMount() {
    const { modalName, onHideRequest } = this.props;
    // Hide the modal that errored out.
    onHideRequest(modalName);
  }

  render() {
    return (
      <div className="modal__body">
        <div className="modal__column">
          <h3 className="text--xl">
            <FormattedMessage id="modalhost.error.heading-line-one" defaultMessage="Could not load content." />
            <br />
            <FormattedMessage id="modalhost.error.heading-line-two" defaultMessage="Please try again." />
          </h3>
          <button className="mt bt bt--primary bt--solid bt--lg" onClick={this.props.onModalClose}>
            <FormattedMessage id="modalhost.error.cta" defaultMessage="Okay" />
          </button>
        </div>
      </div>
    );
  }
}

ModalErrorUnwrapped.propTypes = {
  modalName: PropTypes.string,
  onHideRequest: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
};

export const ModalError = decorateWith(modal(), withName('ModalError'))(ModalErrorUnwrapped);
